import React, { Fragment, useState } from 'react';
import { FaEdit, FaEye, FaTrash } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { TD } from 'styled/table';
import checkPermission from 'utils/checkPermission';
import EditPermissions from './editPermissions';
import permissionConstants from 'utils/permissionConstants';

const ViewPermissionsList = ({ index, role, permissions }) => {
  const [showViewModel, setShowViewModel] = useState(false);
  const [showEditModel, setShowEditModel] = useState(false);
  const currentUser = useSelector((state) => state.user.currentUser);

  return (
    <Fragment>
      <tr key={role?._id} className={`${index % 2 !== 0 && 'bg-gray-100'}`}>
        <TD>{index + 1}</TD>
        <TD>{role?.name}</TD>
        <TD className='text-center'>
          <div className="flex flex-row flex-wrap">
            {role?.permissions?.map((permission) => {
              return (
                <span className="text-sm text-gray-500">
                  {permission?.name},{' '}
                </span>
              );
            })}
          </div>
        </TD>
        <TD>
          {role.createdAt ? new Date(role.createdAt).toLocaleDateString("en-GB").replace(/\//g, '-') : ''}
        </TD>
        <TD className='text-sm text-gray-700 font-medium text-center'>
          {role?.lastUpdatedBy}
        </TD>
        <TD>
          {checkPermission(
            [permissionConstants.manage_roles_and_permissions],
            currentUser
          ) ? (
            <div className="">
              <button
                onClick={() => setShowEditModel(true)}
                className="p-2 m-1  rounded-md bg-green-500 hover:bg-green-600 text-white"
              >
                <FaEdit />
              </button>
              <button
                onClick={() => setShowViewModel(true)}
                className="p-2 m-1 rounded-md bg-yellow-500 hover:bg-yellow-600 text-white"
              >
                <FaEye />
              </button>
            </div>
          ) : (
            <p>----</p>
          )}
        </TD>
      </tr>
      {showViewModel && (
        <EditPermissions
          role={role}
          permissions={permissions}
          desable={true}
          handleClick={() => setShowViewModel(false)}
        />
      )}
      {showEditModel && (
        <EditPermissions
          role={role}
          permissions={permissions}
          handleClick={() => setShowEditModel(false)}
        />
      )}
    </Fragment>
  );
};

export default ViewPermissionsList;
